module.exports = __webpack_public_path__ + "img/3_143.f39e8ac1.png";